import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Sort} from '@angular/material';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';

import {SuppliersService} from './suppliers.service';
import {Suppliers} from './suppliers';
import {SortTable} from './sort-table.component';
import {AppComponent} from './app.component';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const pattern = /^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/; //regex_phone number

@Component({
    selector: 'supplier-list',
    styleUrls: ['./styles/supplier.component.css'],
    templateUrl: './templates/supplier.component.html',
    providers: [SuppliersService, SortTable]
})

export class SupplierListComponent implements OnInit {
    
    supplier_form: FormGroup;
       
    bt_action: string = 'Valider';
    name = 'Supplier List';
    supplier_list: Suppliers[];
    calling_function: string = 'InsertSupplier()';
    id_supplier: number;
    supplier_name: string = '';
    supplier_code: string = '';
    supplier_address: string = '';
    supplier_phone_number: string = '';
    supplier_mail: string = '';
    hide_button = false;
    valid_phone_number = false;

    disabled_input = true;
    modif_title = 'CREATION FOURNISSEUR';

    disabled_validate = true;

    disabled_abstract = true;
    delete_supplier: Suppliers;
    supplier: Suppliers = {
        id_supplier: 0,
        supplier_name: '',
        supplier_code: '',
        supplier_address: '',
        supplier_phone_number: '',
        supplier_mail: ''
    };

    hide_dialog = false;

    edit_supplier_form: FormGroup;
    showForm: boolean = true;
    modification_session: boolean = false;
    showconfirmation: boolean = false;
    sortedData: any = [];

    emailFormControl = new FormControl('', [
        Validators.pattern(EMAIL_REGEX)]);

    phonenumberFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(pattern)]);

    constructor(private products_supplier_service: SuppliersService, private app_component: AppComponent, private router: Router, private fb: FormBuilder, private sort_table: SortTable) {
        this.createForm();
        this.app_component.valTest = '/supplier-list';
        this.app_component.GetParent();
    }
    
    createForm() {
        this.supplier_form = this.fb.group({
            reference_ctl: ['', Validators.required],
            name_ctl: ['', Validators.required],
            code_ctl: ['', Validators.required],
            address_ctl: ['', Validators.required],
            city_ctl: ['', Validators.required],
            country_ctl: ['', Validators.required],
            interloculeur_ctl: ['', Validators.required],
            phone_ctl: ['', Validators.required],
            portable_ctl: ['', Validators.required],
            mail_ctl: ['', Validators.required],
            siteweb_ctl: ['', Validators.required],
            nif_ctl: ['', Validators.required],
            stat_ctl: ['', Validators.required],
            rcs_ctl: ['', Validators.required],
        });
    }
    
    ngOnInit(): void {
        this.SupplierSearch();
    }

   /* createForm() {
        this.edit_supplier_form = this.fb.group({
            name_ctl: ['', Validators.required],
            code_ctl: ['', Validators.required],
            address_ctl: ['', Validators.required],
            tel_ctl: [''],
            mail_ctl: ['']
        });
    }*/

    ValidateButton(): void {
        //Provisoirement pour controler l existance de la valeur phone number
        if (this.supplier.supplier_phone_number === "") {
            this.supplier.supplier_phone_number = null;
        }
        if (this.edit_supplier_form.status === 'VALID' && !(this.emailFormControl.hasError('pattern')) && !(this.phonenumberFormControl.hasError('pattern')) && this.supplier.supplier_phone_number !== null) {
            switch (this.bt_action) {
                case 'Valider':
                    this.InsertSupplier();
                    //this.removeForm();
                    break;
                case 'Modifier':
                    this.ConfirmModification(this.supplier);
                    break;
            };
            //this.emailFormControl.reset();
            this.Reset();
        }
    }

    InsertSupplier(): void {
        this.products_supplier_service.InsertSupplier(this.supplier).then(supplier_list => {this.supplier_list = supplier_list; this.sortedData = supplier_list;});
    }

    ConfirmModification(supplier: Suppliers): void {
        this.products_supplier_service.ConfirmModification(this.supplier).then(supplier_list => {this.supplier_list = supplier_list; this.sortedData = supplier_list;});
    }

    SupplierSearch(): void {
        this.products_supplier_service.SupplierSearch(this.supplier_name, this.supplier_code).then(supplier_list => {this.sortedData = supplier_list; this.supplier_list = supplier_list; this.sort_table.SetDataArray(this.supplier_list, [{value: "supplier_code", type: ""}, {value: "supplier_name", type: ""}, {value: "supplier_address", type: ""}]);});
    }


    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
    }


    SupplierDetails(supplier: Suppliers): void {
        this.modif_title = 'RESUME';
        this.supplier = supplier;

        this.disabled_input = true;
        this.disabled_validate = true;
        this.modification_session = false;
        this.disabled_abstract = false;
        this.edit_supplier_form.disable();
    }

    Init(): void {
        this.supplier.id_supplier = 0,
            this.supplier.supplier_name = '';
        this.supplier.supplier_code = '';
        this.supplier.supplier_address = '';
        this.supplier.supplier_phone_number = '';
        this.supplier.supplier_mail = ''
    }

    ModifySupplier(supplier: Suppliers): void {
        this.supplier = supplier;
        this.bt_action = 'Modifier';
        this.modification_session = true;
        this.disabled_validate = false;
        this.disabled_input = false;
        this.hide_button = true;

        this.modif_title = 'MODIFICATION FOURNISSEUR';
        this.edit_supplier_form.enable();
    }

    DeleteSupplier(): void {
        this.products_supplier_service.DeleteSupplier(this.delete_supplier).then(supplier_list => {this.supplier_list = supplier_list; this.sortedData = supplier_list});
        this.Reset();
        this.hide_dialog = false;
    }

    DialogCancel(): void {
        this.showconfirmation = false;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    DialogConfirm(supplier: Suppliers): void {
        this.delete_supplier = supplier;
        this.showconfirmation = true;
        this.app_component.hide_wrapper(this.showconfirmation);
    }

    EditSupplier(): void {
        this.products_supplier_service.EditSupplier(this.supplier).then(supplier_list => {this.supplier_list = supplier_list; this.sortedData = supplier_list});
        this.Reset();
    }

    ValideModification(): void {
        if (this.edit_supplier_form.status == 'VALID') {
            this.EditSupplier();
        }
    }

    Reset(): void {
        this.emailFormControl.reset();
        this.phonenumberFormControl.reset();
        this.edit_supplier_form.reset();
        this.showForm = false;
        setTimeout(() => {
            this.edit_supplier_form.reset();
            this.modification_session = false;
            this.showconfirmation = false;
            this.disabled_abstract = true;
            this.app_component.hide_wrapper(this.showconfirmation);
            this.bt_action = 'Valider';
            this.modif_title = 'CREATION FOURNISSEUR';
            this.createForm();
            this.showForm = true;
            this.hide_button = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/suppliers-list.component.ts